const ROOT_URI = '/agent/policies';

export default {
  POLICIES: ROOT_URI,
  POLICY_DETAILS_API: (version: string) => `/api/policies/v${version}/policyNumber/details/get`,
  CORRESPONDENCE_SUMMARIES: (policyNumber?: string, accountNumber?: string, insuredName?:string) =>
    `${ROOT_URI}/correspondence?${
      policyNumber ? `policyNumber=${policyNumber}` : ''}${
        accountNumber ? `accountNumber=${accountNumber}` : ''}${
          insuredName ? `insuredName=${insuredName}` : ''}`,
  PENDING_UNDERWRITING_REQUIREMENT: `${ROOT_URI}/pendingUnderwritingRequirements`,
  POLICY_SERVICE_REQUEST: `${ROOT_URI}/serviceRequest`,
  CORRESPONDENCE_DETAILS: (letterNumber: string, queryString?: string) =>
    `${ROOT_URI}/correspondence/${letterNumber}${queryString}`,
  POLICIES_BY_ACCOUNT: (accountNumber: string) => `${ROOT_URI}?accountNumber=${accountNumber}`,
  POLICIES_BY_INSURED_NAME: (insuredName: string) => `${ROOT_URI}?insuredName=${insuredName}`,
  POLICIES_BY_LAST_4_OF_SSN: (last4ofSSN: string) => `${ROOT_URI}?last4OfSSN=${last4ofSSN}`,
  POLICIES_BY_LAST_4_OF_OWNER_SSN: (last4ofSSN: string) => `${ROOT_URI}?last4OfOwnerSSN=${last4ofSSN}`,
  POLICIES_BY_PAYOR_NAME: (payorName: string) => `${ROOT_URI}?payorName=${payorName}`,
  POLICIES_BY_POLICY_NUMBER: (policyNumber: string) => `${ROOT_URI}?policyNumber=${policyNumber}`,
  POLICY_DETAILS: (policyId: string, policyNumber: string, source: string) =>
    `${ROOT_URI}/${policyId}/policyNumber/${policyNumber}?source=${source}`,
  POLICY_UPLOAD_DOCUMENT: (policyId: string, policyNumber: string) =>
    `${ROOT_URI}/${policyId}/policyNumber/${policyNumber}/upload`,
  POLICY_APPLICATIONS: `${ROOT_URI}/applications`,
  POLICY_APPLICATIONS_API: (version: string) => `/api/policies/v${version}/applications/get`,
};
